export default __webpack_public_path__ + "static/media/buildResumeFlow.81aa3075.png";